import React from 'react'
import { Box, Button, Skeleton, Typography } from '@mui/material'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { DirectTabLoader } from '../../../../../../core/loader/DirectTabLoader'
import { domain } from '../../../../../../core/Env';


export const Top = ({ themeBtn, tLoader, templateForm, company_id, handleThemes }) => {
    const nav = useHistory();
    const gotoWebsite = async (wId) => {
        let ssoUrls = `${domain('shp').url}/psl/ws/realproperty/${window.btoa(`${company_id}`)}_${window.btoa(`${wId}`)}?type=property-rent`
        await DirectTabLoader('ShpWN', ssoUrls)
    };
    const handlePreview = async () => {
        nav.push('/campaign/website?type=real-property&tab=list&offer_type=rent&property_type=all')
    }

    return (
        <Box width="100%" height="100%" bgcolor="#E8ECF0" position="relative" display="flex" justifyContent="center">
            {
                !themeBtn.data.theme &&
                <Box position="absolute" top={0} width={420} height="100%" display="flex" justifyContent="center" p={.5}
                // bgcolor='#c0c0c0'
                >
                    {!tLoader.data ? (
                        <Box display="flex" alignItems="center" gap={3} borderRadius={1.5} bgcolor="#fff" px={1} py={.5}>
                            <Box width="100%">
                                {templateForm.data.status === 2 ?
                                    <Box width="100%" display="flex" alignItems="center" gap={1}>
                                        <Box variant="outlined" py={0.5} width={120} fontSize={12} component={Button} sx={{ bgcolor: "#E8E8E8", color: "#080808", "&:hover": { bgcolor: "#E8E8E8" } }} onClick={() => gotoWebsite(templateForm.data.id)} >Go to Site</Box>
                                        <Box variant="contained" py={0.5} width={120} fontSize={12} component={Button} sx={{ bgcolor: "#1976d2", color: "#fff", "&:hover": { bgcolor: "#1565c0" } }} onClick={() => handleThemes('theme', 'update')} >Customize</Box>
                                    </Box>
                                :
                                    <Box width="100%" display="flex" alignItems="center" gap={1}>
                                        <Box variant="outlined" py={0.5} width={120} fontSize={12} component={Button} sx={{ bgcolor: "#E8E8E8", color: "#080808", "&:hover": { bgcolor: "#E8E8E8" } }} onClick={() => handlePreview()} >Live Preview</Box>
                                        {/* <Box variant="contained" py={0.5} width={120} fontSize={12} component={Button} sx={{ bgcolor: "#1976d2", color: "#fff", "&:hover": { bgcolor: "#1565c0" } }} onClick={() => handleThemes('theme', 'create')} >Activate</Box> */}
                                        <Box variant="contained" py={0.5} width={120} fontSize={12} component={Button} sx={{ bgcolor: "#1976d2", color: "#fff", "&:hover": { bgcolor: "#1565c0" } }} onClick={() => handleThemes('theme', templateForm.data.status === 1 ? 'update' : 'create')} >Activate</Box>
                                    </Box>
                                }
                            </Box>
                            <Typography width="100%" >
                                Template &nbsp; {templateForm.data.template_id}
                            </Typography>
                        </Box>) : <Skeleton variant='rounded' width="100%" height={40} />
                    }
                </Box>
            }
        </Box>
    )
}
